import { useMutation } from '@tanstack/react-query'
import { registeredConsumersForBabysitterId } from '../index'

const usePostConsumersForBabysitter = () => {
  return useMutation({
    mutationFn: ({
      limit,
      page,
      payload,
    }: {
      limit: number
      page: number
      payload: { babysitterUserId: string }
    }) => registeredConsumersForBabysitterId({ limit, page, payload }),
  })
}

export default usePostConsumersForBabysitter
